module.exports = {
      id: "arrow-down-black-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#arrow-down-black",
      toString: function () {
        return this.url;
      }
    }